// shared functions between modal components
import { isPlatformBrowser } from '@angular/common'

/**
 * important mobile scroll to top on loading
 */
export function scrollModalToTop() {
  if (!isPlatformBrowser(this.platformId)) {
    return;
  }
  const modal = document.getElementById('topOfTheModal')
  if (modal) {
    modal.scrollTo({
      top: 0
    })
  }
}

/**
 * 1 for QA testing;
 * 9 for production
 */
export const SESSION_TIMER_MINUTES = 9


/**
 * select mobile input, set active and set value
 * @param targetElementId div with mobile input
 */
export function mobileSetValueInputArea(targetElementId: string, inputId: string, value: any): void {
  if (!isPlatformBrowser(this.platformId)) {
    return;
  }
  const targetElement = document.getElementById(targetElementId)
  if (targetElement.classList.contains('input-area__inactive')) {
    targetElement.classList.remove('input-area__inactive')
    targetElement.classList.add('input-area__active')
    const el: any = document.getElementById(inputId)
    if (el) {
      el.value = value
    }
  }
}
